import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "../../../../components/UI/Button/Button";
import "./InterviewSchedulerList.css";
import axios from "../../../../services/axios-service";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/index";
import SearchBox from "../../../../components/UI/SearchBox/SearchBox";
import searchIcon from "../../../../assets/images/interview-search.svg";
import Modal from "../../../../components/UI/Modal/Modal";
import MediaQuery from "react-responsive";
import { Table } from "react-bootstrap";
import Icon from "../../../../components/UI/Icon/Icon";
import withErrorHandler from "./../../../../hoc/withErrorHandler/withErrorHandler";
import ConsoleLog from "./../../../../hoc/ConsoleLog/ConsoleLog";
import Loader from "../../../../components/UI/Loader/Loader";

class InterviewSchedulerList extends Component {
  state = {
    interviewScheduledDetails: null,
    loading: true
  };

  componentDidMount() {
    this.fetchInterviewList();
  }

  /**
   * @desc fetches the interview
   * @param interviewId
   * @return null
   */

  fetchInterviewList = () => {
    axios
      .get(
        "/galaxy/interview?recruiterId=" + this.props.recruiterDetails.user_id
      )
      .then(response => {
        ConsoleLog("response notification", response.data);
        const interviewScheduledDetails = response.data;
        // for(var i=0;i<=interviewScheduledDetails.interviews.length;i++){
        //   interviewScheduledDetails.interviews[i].candidate_recieved_count='4';
        // }
        ConsoleLog("interviewScheduledDetails", interviewScheduledDetails);
        this.setState({ interviewScheduledDetails, loading: false });
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  reviewInterviewList = id => {
    ConsoleLog("id here", id);
    this.props.history.push({
      pathname: "/recruiter/interview",
      state: { clientId: id }
    });
  };

  viewInterviewList = id => {
    ConsoleLog("id here", id);
    this.props.history.push({
      pathname: "/recruiter/interview-view",
      state: { interviewId: id }
    });
  };

  render() {
    return (
      <div className="interview-list-container">
        {this.state.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            {this.state.interviewScheduledDetails &&
            this.state.interviewScheduledDetails.interviews.length > 0 ? (
              <div className="interview-list-heading">
                <h1>Interview list</h1>
                <div className="mob-hrline"></div>
              </div>
            ) : (
              ""
            )}
            <MediaQuery query="(max-device-width: 769px)">
              {this.state.interviewScheduledDetails &&
              this.state.interviewScheduledDetails.interviews.length > 0 ? (
                this.state.interviewScheduledDetails.interviews.map(
                  (interview, index) => {
                    const interviewStatus =
                      interview.client_interview_status === "Completed" &&
                      interview.responded == interview.total
                        ? "Completed"
                        : interview.client_interview_status === "Completed" &&
                          interview.responded !== interview.total
                        ? "Awaiting candidate responses"
                        : "Pending Recruiter Review";
                    const interviewStatusIcon =
                      interview.client_interview_status === "Completed" &&
                      interview.responded == interview.total
                        ? "accepted-icon"
                        : interview.client_interview_status === "Completed" &&
                          interview.responded !== interview.total
                        ? "awaiting"
                        : "rec-pending-icon";
                    const interviewStatusClass =
                      interview.client_interview_status === "Completed" &&
                      interview.responded == interview.total
                        ? "Completed"
                        : interview.client_interview_status === "Completed" &&
                          interview.responded !== interview.total
                        ? "Awaiting"
                        : "Pending";
                    const interviewViewButton =
                      interview.client_interview_status === "Pending"
                        ? () =>
                            this.reviewInterviewList(
                              interview.client_interview_id
                            )
                        : () =>
                            this.viewInterviewList(
                              interview.client_interview_id
                            );
                    const interviewButtonLabel =
                      interview.client_interview_status === "Pending"
                        ? "Review"
                        : "View";
                    const candidateReceivedCheck =
                      interview.total === 1
                        ? " candidate received"
                        : " candidates received";
                    const candidateRespondedCheck =
                      interview.total === 1
                        ? " candidate responded"
                        : " candidates responded";
                    return (
                      <div
                        className={
                          "interviewlist-mobile-card " + interviewStatusClass
                        }
                      >
                        <div className="interview-list-date">
                          Date created{" "}
                          <span className="date-mob">
                            {new Date(interview.created_date)
                              .toISOString()
                              .replace(/T.*/, "")
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                        </div>
                        <div className="interview-list-job-details">
                          {interview.job_details}
                        </div>
                        <div className="interview-list-company">
                          <span className="company-mob">Company</span>
                          {interview.company_name}
                        </div>
                        <div className="interview-list-location">
                          <span className="location-mob">Location</span>
                          {interview.client_interview_location}
                        </div>
                        <div className="card-hrline-mob">
                          <hr />
                        </div>
                        <div className="interview-status">
                          <Icon
                            className={
                              "interview-status-icon " + interviewStatusClass
                            }
                            icon={interviewStatusIcon}
                          />{" "}
                          <span>{interviewStatus}</span>
                          <span className="received-candidate">
                            {interview.client_interview_status === "Pending"
                              ? interview.total + candidateReceivedCheck
                              : interview.responded +
                                "/" +
                                interview.total +
                                candidateRespondedCheck}
                          </span>
                        </div>
                        <Button
                          className={
                            "interview-view-review " + interviewButtonLabel
                          }
                          onClick={interviewViewButton}
                        >
                          {interviewButtonLabel}
                        </Button>
                      </div>
                    );
                  }
                )
              ) : (
                <div className="no-interviews">
                  <p>There are no interviews currently scheduled.</p>
                </div>
              )}
            </MediaQuery>
            {/* Mobile view Ends */}
            {/* Desktop view starts */}
            <MediaQuery query="(min-device-width: 768px)">
              {this.state.interviewScheduledDetails &&
              this.state.interviewScheduledDetails.interviews.length > 0 ? (
                <div className="interview-list-main-table">
                  <Table className="interview-List-Table" striped condensed>
                    <thead className="interview-list-table-thead">
                      <tr>
                        <th className="interview-list-date">Date Created</th>
                        <th className="interview-list-job-details">
                          Job Details
                        </th>
                        <th className="interview-list-company">Company</th>
                        <th className="interview-list-location">Location</th>
                        <th className="interview-list-status">Status</th>
                        <th className="interview-list-review"></th>
                      </tr>
                    </thead>
                    <tbody className="interview-list-table-body">
                      {this.state.interviewScheduledDetails.interviews.map(
                        (interview, index) => {
                          const interviewStatus =
                            interview.client_interview_status === "Completed" &&
                            interview.responded == interview.total
                              ? "Completed"
                              : interview.client_interview_status ===
                                  "Completed" &&
                                interview.responded !== interview.total
                              ? "Awaiting candidate responses"
                              : "Pending Recruiter Review";
                          const interviewStatusIcon =
                            interview.client_interview_status === "Completed" &&
                            interview.responded == interview.total
                              ? "accepted-icon"
                              : interview.client_interview_status ===
                                  "Completed" &&
                                interview.responded !== interview.total
                              ? "awaiting"
                              : "rec-pending-icon";
                          const interviewStatusClass =
                            interview.client_interview_status === "Completed" &&
                            interview.responded == interview.total
                              ? "Completed"
                              : interview.client_interview_status ===
                                  "Completed" &&
                                interview.responded !== interview.total
                              ? "Awaiting"
                              : "Pending";
                          const interviewViewButton =
                            interview.client_interview_status === "Pending"
                              ? () =>
                                  this.reviewInterviewList(
                                    interview.client_interview_id
                                  )
                              : () =>
                                  this.viewInterviewList(
                                    interview.client_interview_id
                                  );
                          const interviewButtonLabel =
                            interview.client_interview_status === "Pending"
                              ? "Review"
                              : "View";
                          const candidateReceivedCheck =
                            interview.total === 1
                              ? " candidate received"
                              : " candidates received";
                          const candidateRespondedCheck =
                            interview.total === 1
                              ? " candidate responded"
                              : " candidates responded";
                          return (
                            <tr key={index}>
                              <td className="interview-list-date">
                                {new Date(interview.created_date)
                                  .toISOString()
                                  .replace(/T.*/, "")
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="interview-list-job-details">
                                {interview.job_details}
                              </td>
                              <td className="interview-list-company">
                                {interview.company_name}
                              </td>
                              <td className="interview-list-location">
                                {interview.client_interview_location}
                              </td>
                              <td className="interview-list-status">
                                <Icon
                                  className={
                                    "interview-status-icon " +
                                    interviewStatusClass
                                  }
                                  icon={interviewStatusIcon}
                                />
                                {interviewStatus}
                                <span className="received-candidate">
                                  {interview.client_interview_status ===
                                  "Pending"
                                    ? interview.total + candidateReceivedCheck
                                    : interview.responded +
                                      "/" +
                                      interview.total +
                                      candidateRespondedCheck}
                                </span>
                              </td>
                              <td
                                className={
                                  "interview-action " + interviewStatusClass
                                }
                              >
                                <Button
                                  className={
                                    "interview-view-review " +
                                    interviewButtonLabel
                                  }
                                  onClick={interviewViewButton}
                                >
                                  {interviewButtonLabel}
                                </Button>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="no-interviews">
                  <p>There are no interviews currently scheduled.</p>
                </div>
              )}
            </MediaQuery>
          </React.Fragment>
        )}
      </div>
    );
  }
}
/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => {
  return {
    recruiterDetails: state.clientProfile.clientDetails,
    user: state.cognito.user,
    attributes: state.cognito.attributes
  };
};
export default connect(mapStateToProps)(
  withErrorHandler(InterviewSchedulerList, axios)
);



// WEBPACK FOOTER //
// ./src/container/Recruiter/RecruiterInterviewDetails/InterviewSchedulerList/InterviewSchedulerList.js